import { allFilterOptionValue } from '../../../utils/filters/constants';
export const getUpdatedSelectedValuesForFilterKey = (currentSelection, filterValue, multiselect) => {
    if (filterValue === allFilterOptionValue) {
        return [];
    }
    if (!multiselect) {
        return [filterValue];
    }
    const index = currentSelection.findIndex(v => v === filterValue);
    if (index >= 0) {
        currentSelection.splice(index, 1);
    }
    else {
        currentSelection.push(filterValue);
    }
    return currentSelection;
};
